import axios from '@/axiosInterceptor';

const state = () => ({
  companyData: [],
});

// getters
const getters = {};

// actions
const actions = {
  async getCompanyByClientId({ commit }, client_id) {
    try {
      let res = await axios.get(
        process.env.API_IDENTITY +
          '/api/v1/companies/' +
          client_id +
          '/by_client_id',
        client_id
      );
      await commit('setCompanyData', res.data);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (
        axios.isAxiosError(e) &&
        status &&
        [401, 403, 404, 422].includes(status)
      ) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

// mutations
const mutations = {
  setCompanyData(state, el) {
    state.companyData = el;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
